import { Panel } from 'primereact/panel';
import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { RootState } from '../reducers';
import useEffectOnce from '../hooks/useEffectOnce';
import { fetchChatDatasss, fetchDocumentsData, fetchPatientDetails, GetPat, UploadImageData, ViewDocument } from '../reduxactions/doctoractions/DoctorViewCaseActions';
import './Patient.css';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Admin_API, DOCTOR_API, PATIENT_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dialog } from 'primereact/dialog';
// import './DoctorViewOpenCase.css';
import { FileUpload, FileUploadHandlerEvent } from 'primereact/fileupload';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';

export const ViewPatientCases = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const stepperRef = useRef(null);

    const location = useLocation();
    const dispatch = useDispatch();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("id") as any);
    }, [location]);
    const { id } = useParams();
    const getData = useSelector((state: RootState) => state.doctorviewopencase.get);
    const chatdata = useSelector((state: RootState) => state.doctorviewopencase.chat);
    const docdatass = useSelector((state: RootState) => state.doctorviewopencase.docdata);
    const pat = useSelector((state: RootState) => state.doctorviewopencase.patient);
    const Doctorname = `${getData[0]?.FirstName} ${getData[0]?.LastName}`;
    console.log('getData:', getData);

    useEffect(() => {
        fetchDataAsync();
        fetchchatData();
        fetchDataAsync2();
        getpt();
    }, [dispatch]);
    //To get data
    const fetchDataAsync = async () => {
        try {
            await dispatch(fetchPatientDetails(uid, id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const fetchchatData = async () => {
        try {
            console.log("dispatch");
            await dispatch(fetchChatDatasss(uid, id) as any);
        } catch (error) {
            console.log("catch");
            console.error('Error fetching data:', error);
        }
    };
    const fetchDataAsync2 = async () => {
        try {

            await dispatch(fetchDocumentsData(uid, id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };


    const getpt = async () => {
        try {
            await dispatch(GetPat(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const [messege, setMessage] = useState('');
    const sendChat = async () => {
        try {
            const payload = { q: 5, uid: uid, need: id, message: messege };
            const apiname = DOCTOR_API.doctorcasedetails_API;
            const response = await LoginService.getData(apiname, payload);
            fetchchatData();
            setMessage('');
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //view doc
    const [ViewDilog, setViewDilog] = useState(false);
    const viewdocs = useSelector((state: RootState) => state.doctorviewopencase.viewdoc);

    // const viewuploaddata = (rowData: any) => {

    //     . = { 
    //         DocID: rowData.DocID 

    //     }
    //     setViewDilog(true);
    // };
    // const assignData = useRef({
    //      DocID: '' ,
    //      fullfile:'',

    // });
    const [editData, setEditData] = useState({
        DocID: '',
        fullfile: '',
    });

    const Editdata = (rowData: any) => {
        setEditData({
            DocID: rowData.DocID,
            fullfile: rowData.fullfile,

        });
        setViewDilog(true);
        viewData();
    }


    const viewData = async () => {
        try {
            const { DocID } = editData;
            await dispatch(ViewDocument(DocID) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }

    }

    const navigate = useNavigate();
    const viewPatientHis = (rowData: any) => {
        const url = `/viewpatienthistory/${rowData.PatientID}`;
        navigate(url);
    };

    //add appointments
    const [addDilog, setaddDilog] = useState(false);
    const [sdate, setSdate] = useState('');
    const [Description, setDescription] = useState('');
    const [time, setTime] = useState('');
    const [duration, setDuration] = useState('');
    const close = () => {
        setaddDilog(false);
        setAdddocument(false);
    };
    // const toast = useRef('');
    const addVolunteerDataAsync = async () => {
        if (!Description || !duration || !sdate) {
            //toast.current.show({ severity: 'error', detail: 'Please fill in all required fields.', life: 3000 });
            return;
        }
        try {
            const payload = { description: Description, duration: duration, need: id, sdate: sdate, stime: time, uid: uid, q: 8 };
            const apiname = DOCTOR_API.doctorcasedetails_API;
            const response = await LoginService.getData(apiname, payload);
            //   if(response==="Successfully appointment added."){
            //     toast.current.show({ severity: 'success', detail: 'Successfully appointment added.', life: 3000 });
            //   }
            setaddDilog(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //upload
    const [Adddocument, setAdddocument] = useState(false);
    const [docname, setDocument] = useState<string>('');

    const imagesssss = useSelector((state: RootState) => state.doctorviewopencase.uploaddoc);
    const [selectedFile, setSelectFile] = useState<File | null>(null);

    const UploadManagerImage = async (event: FileUploadHandlerEvent) => {
        const files = event.files;
        if (files.length > 0) {
            const file = files[0];
            console.log("file:", file);
            setSelectFile(file);
            console.log("called image function:", file)
            try {
                await dispatch(UploadImageData(file, id) as any);
            } catch (error) {
                console.error('Error uploading image:', error);
            }
        }

    };
    const toast = useRef<Toast>(null);
    const Upload = async () => {
        try {
            const filename = imagesssss?.filename;
            const payload = { q: 6, uid: uid, need: id, doctitle: docname, filename: filename };
            const apiname = DOCTOR_API.doctorcasedetails_API;
            const response = await LoginService.getData(apiname, payload);
            if (toast.current) {
                toast.current.show({ severity: 'success', detail: response });
            }
            fetchDataAsync2();
            setAdddocument(false);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //remove and close dilog
    const [RemoveDilog, setRemoveDilog] = useState(false);
    const [suggestion, setSuggestion] = useState('');
    const FeedbackOptions = [
        { label: 'Very Satisfied', value: '1' },
        { label: 'Poor', value: '2' },
        { label: 'Satisfactory', value: '3' },
        { label: 'Good', value: '4' },
        { label: 'Excellent', value: '5' },
    ];
    const [closeCaseDilog, setCloseCaseDilog] = useState(false);
    const [closesuggestion, setCloseSuggestion] = useState('');
    const [Experience, setExperience] = useState('');
    const toast1 = useRef<Toast>(null)
    const CloseCase = async () => {
        try {
            const payload = { need: id, rate: Experience, suggest: closesuggestion, uid: uid, q: 9 };
            const apiname = Admin_API.viewcases_API;
            const response = await LoginService.getData(apiname, payload);
            if (toast1.current) {
                toast1.current.show({ severity: 'success', detail: response });
            }
            setCloseCaseDilog(false);
            setTimeout(() => {
                navigate('/patientcases');
            }, 3000)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };

    const RevokeCase = async () => {
        try {
            const payload = { need: id, suggest: suggestion, uid: uid, q: 9 };
            const apiname = Admin_API.viewcases_API;
            const response = await LoginService.getData(apiname, payload);
            if (toast1.current) {
                toast1.current.show({ severity: 'success', detail: response });
            }
            setRemoveDilog(false);
            setTimeout(() => {
                navigate('/patientcases');
            }, 3000)
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewopenedcases.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="main-content">
                <div className="content-wrapper">
                    <div className="grid">
                        <div className="col-9">
                            <h2 style={{ fontWeight: '480', fontSize: '34px', marginLeft: '-45px' }}>Case Details</h2>
                        </div>
                        <div className="col-3">
                <a
                  title="help"
                 onClick={(e) => openWindow(e, IUrl)}
                  style={{
                   
                    color: "blue",
                    fontSize: 15, cursor: "pointer"
                  }}
                >Help for this Page &nbsp;
                <i style={{marginTop: 40,backgroundColor: "orange",color:"white" }} className = "pi pi-question-circle"></i>
                 
                </a>
              </div>
                    </div>
                    {pat[0]?.CaseStatus === 'OPEN' && (
                        <div className='col-12'>
                            <h2 style={{ fontWeight: '480', fontSize: '30px', textAlign: 'left', marginLeft: '25px', marginBottom: '-30px', marginTop: '-20px' }}>Doctor : {Doctorname}</h2>

                            <Button label="Revoke Access" style={{ marginRight: '50px', background: "white", color: "rgb(220, 53, 69)", border: "1px solid red", marginBottom: '50px' }} className="hover-red" onClick={() => setRemoveDilog(true)} />

                            <Button label="Case Close" style={{ marginRight: '50px', background: "white", color: "rgb(40, 167, 69)", border: "1px solid green", marginBottom: '50px' }} className="hover-green" onClick={() => setCloseCaseDilog(true)} />
                        </div>
                    )}
                    {pat[0]?.CaseStatus === 'CLOSE' && (
                        <div className='col-12'>
                            <h2 style={{ fontWeight: '480', fontSize: '30px', textAlign: 'left', marginLeft: '40px', marginBottom: '50px' }}>Doctor : {Doctorname}</h2>

                            <Button label="This Case was Closed!" style={{ background: "white", color: "rgb(220, 53, 69)", border: "1px solid red", marginBottom: '15px', width: '1120px' }} className="hover-red" />


                        </div>
                    )}
                    <section className="content">
                        <div className="grid">
                            <div className='col-9'>
                                <Panel header="Direct Chat" toggleable style={{ width: '1150px', marginTop: '-20px' }}>
                                    <Card>
                                        <div className="grid">
                                            <div className="col-12">
                                                {chatdata && chatdata.length > 0 ? (
                                                    chatdata.map((item: any, index: any) => (
                                                        <div key={item.id || index} style={{ display: 'flex', alignItems: 'center', marginBottom: '15px' }}>
                                                            <img
                                                                className="direct-chat-img"
                                                                src={item.photo}
                                                                alt="User Avatar"
                                                                style={{ width: '50px', height: '50px', borderRadius: '50%', marginRight: '15px', border: '0.4px solid rgba(0, 0, 0, 0.125)' }}
                                                            />
                                                            <div>
                                                                <span style={{ marginLeft: '-10px' }}>{item.name}</span>
                                                                <span style={{ color: 'gray', marginLeft: '6px' }}>{item.date}</span>
                                                            </div>
                                                            <p style={{ marginLeft: '35px' }}>{item.msg}</p>
                                                        </div>
                                                    ))
                                                ) : (
                                                    <p>No chat data available.</p>
                                                )}
                                            </div>
                                            <div className='col-12' style={{ position: 'relative', marginTop: '20px' }}>
                                                <InputText value={messege} placeholder="Type Message ..." style={{ width: '90%', paddingRight: '5px', marginRight: '10px' }} onChange={(e) => setMessage(e.target.value)}
                                                />

                                                <Button severity="info" icon="pi pi-send" style={{ backgroundColor: 'white', color: 'green', borderRadius: '25px', border: '2px solid green' }} onClick={sendChat} />
                                            </div>
                                        </div>
                                    </Card>


                                    <Panel header="Document Uploads" toggleable>

                                        <section className="content">
                                            <div className="grid">
                                                <div className="col-12">
                                                    <div className="card card-primary">
                                                        {pat[0]?.CaseStatus === 'OPEN' && (
                                                            <div className="card flex flex-wrap justify-content-end">
                                                                <Button label="Upload Docs" severity="info" onClick={() => setAdddocument(true)} style={{ marginRight: '50px', background: "rgba(59,130,246,.04)", color: "#3b82f6", border: "1px solid" }} />
                                                            </div>
                                                        )}
                                                        <div className="card card-primary">
                                                            <div className="card flex flex-wrap justify-content">
                                                            </div>
                                                            <DataTable value={docdatass} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                                                <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                                <Column field="doc_name" sortable header="Document Title"></Column>
                                                                <Column header="Operation" body={(rowData) => (
                                                                    <>
                                                                        <Button icon="pi pi-eye" rounded outlined tooltip="View" style={{ backgroundColor: 'white', color: 'blue' }} onClick={() => Editdata(rowData)} ></Button>
                                                                    </>
                                                                )} />
                                                            </DataTable>
                                                        </div>

                                                    </div>

                                                </div>
                                            </div>
                                        </section>
                                    </Panel>
                                </Panel>
                            </div>
                        </div>

                    </section>

                </div>
            </div>
            {/* view dilog */}
            <Dialog header="View" style={{ width: '50vw' }} visible={ViewDilog} onHide={() => setViewDilog(false)}>
                <div className="modal-header">
                </div>
                <div className="modal-body">
                    {viewdocs.map((response: any, index: number) =>
                        <div key={index}>
                            <img src={editData.fullfile} alt="Doc" width="100%" height="auto" />
                        </div>
                    )}
                </div>
            </Dialog>
            {/* add dilog */}
            <Dialog header="Upload Document" visible={Adddocument} style={{ width: '30vw', height: '40' }} onHide={() => setAdddocument(false)} >

                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Doc Title:</label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            id="name"
                            style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
                            type='text'
                            value={docname}
                            name="Contest Name"
                            placeholder='Document Title'
                            onChange={(e) => setDocument(e.target.value)}
                        />
                    </div>
                </div>
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Select File:</label>
                    </div>
                    <div className="col-6" style={{ marginLeft: '30px' }} >
                        <FileUpload mode="basic" id="fileToUpload" name="fileToUpload" customUpload accept="image/*" maxFileSize={1000000} uploadHandler={UploadManagerImage} auto />
                        {selectedFile && <p style={{ marginTop: '10px' }}>{selectedFile.name}</p>}
                    </div>
                </div>
                <div className='grid' style={{ justifyContent: 'space-evenly', marginTop: '15px' }}>
                    <Button label="Close" onClick={close} severity="secondary" />
                    <Button label="Add" onClick={Upload} />
                </div>
            </Dialog>
            {/* <Dialog header="Access" visible={RemoveDilog} style={{ width: '40vw', height: '50vh' }} onHide={() => setRemoveDilog(false)} >
                <div className="grid pt-0" style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
                    <label htmlFor="name"  className="control-label">
                        Do you really want to Remove Access History
                    </label>
                    <label htmlFor="suggestion" style={{ marginLeft: '20px', marginBottom: '40px', fontWeight: '800' }} className="control-label">
                        Suggestions :
                    </label>
                    <InputText
                        id="suggestion"
                        style={{ width: '18vw', marginBottom: '50px', marginLeft: '10px' }}
                        name="Contest Name"
                        placeholder='Enter Suggestions'
                        onChange={(e) => setSuggestion(e.target.value)}
                    />
                </div>
                <Button label="Save Changes" style={{ float: 'right' }} onClick={RevokeCase} />
            </Dialog> */}
            <Dialog
  header="Access"
  visible={RemoveDilog}
  style={{ width: '40vw' }}
  onHide={() => setRemoveDilog(false)}
>
  <div className="grid p-fluid">

    {/* Question */}
    <div className="col-12">
      <p>Do you really want to Remove Access History</p>
    </div>

    {/* Suggestion label */}
    <div className="col-12">
      <label htmlFor="suggestion" className="font-semibold">
        Suggestion
      </label>
    </div>

    {/* Textarea */}
    <div className="col-12">
       <InputText
                        id="suggestion"
                        style={{ width: '18vw', marginBottom: '50px', marginLeft: '10px' }}
                        name="Contest Name"
                        placeholder='Enter Suggestions'
                        onChange={(e) => setSuggestion(e.target.value)}
                    />
    </div>

    {/* Button */}
    <div className="col-12 flex justify-content-end mt-3">
      <Button label="Save changes" onClick={RevokeCase} />
    </div>

  </div>
</Dialog>

            <Dialog header="Default Model" visible={closeCaseDilog} style={{ width: '34vw', height: '48vh' }} onHide={() => setCloseCaseDilog(false)} >
                <div className="grid pt-0" style={{ marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="name" className="col-sm-2 control-label">Overall Experience With Us:</label>
                    </div>
                    <div className="col-6" >
                        <Dropdown id="type" value={Experience} onChange={(e) => setExperience(e.value)} className="custom-dropdown-placeholder" options={FeedbackOptions} optionLabel="label" optionValue="value" placeholder="Select Experience" style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }} />
                    </div>
                </div>
                <div className="grid pt-0" style={{ display: 'flex', alignItems: 'center', marginBottom: '2px' }}>
                    <div className="col-3">
                        <label htmlFor="suggestion" className="col-sm-2 control-label">
                            Suggestions :
                        </label>
                    </div>
                    <div className="col-6" >
                        <InputText
                            className="custom-dropdown-placeholder"
                            id="suggestion"
                            style={{ width: '18vw', marginBottom: '20px', marginLeft: '25px' }}
                            name="Contest Name"
                            placeholder='Enter Suggestions'
                            onChange={(e) => setCloseSuggestion(e.target.value)}
                        />
                    </div>
                </div>

                <Button label="Save Changes" style={{ float: 'right' }} onClick={CloseCase} />
            </Dialog>

            <Toast ref={toast1} ></Toast>
            <Toast ref={toast} ></Toast>


        </div>

    )
}